import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { InlineCompareButtonsWithGroupId } from "./inline-compare-buttons-with-group-id"
import { InlineCompareButtonsBase } from "./inline-compare-button-base"

export function InlineCompareButtons({ idFromGroup, to, from, rendered }) {
    const { schedule, canSave, popupEditor, groupReviewId, taskAudits = [], reviewReferenceId } = useBoundContext()
    const referenceId = `${schedule.id}-version:${parseInt(schedule.version) + 1}`
    const taskId = to?.taskId ?? `${to?.id ?? schedule.id}-${idFromGroup.replaceAll(" ", "-")}`
    const audits = taskAudits.filter((task) => task.payload?.taskId === taskId).sortBy("date", true)
    const latestTaskAudit = audits?.[0] ?? {}

    if (!groupReviewId) {
        return (
            <InlineCompareButtonsBase
                idFromGroup={idFromGroup}
                to={to}
                from={from}
                rendered={rendered}
                schedule={schedule}
                canSave={canSave}
                popupEditor={popupEditor}
                groupReviewId={groupReviewId}
                referenceId={reviewReferenceId ?? referenceId}
                taskId={taskId}
                audit={null}
                latestTaskAudit={latestTaskAudit}
            />
        )
    }

    return (
        <InlineCompareButtonsWithGroupId
            idFromGroup={idFromGroup}
            to={to}
            from={from}
            rendered={rendered}
            schedule={schedule}
            canSave={canSave}
            popupEditor={popupEditor}
            groupReviewId={groupReviewId}
            referenceId={reviewReferenceId ?? referenceId}
            taskId={taskId}
            latestTaskAudit={latestTaskAudit}
        />
    )
}
